module.exports = __webpack_public_path__ + "static/media/21-2.121c748d.mp3";